/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Categoria di personale per i pasti dipendenti di una scuola del servizio mensa
 */
export enum CategoriaDipendenteMensa {

    DOCENTE = 'DOCENTE',

    ATA = 'ATA',

    TECNICO = 'TECNICO',

    COLLABORATORE = 'COLLABORATORE'
}

